import React from "react";
import { DialogPanel, DialogTitle, TransitionChild } from "@headlessui/react";
import { X } from "lucide-react";
import { useIntl } from "react-intl";
import { IconButton } from "../../iconButton/iconButton";
// Enters/leaves from the right — a surface returns the way it came (DESIGN.md §13).
export default function ModalRightCore({ setOpen, title, children, maxWidth = "max-w-md" }) {
    const { formatMessage } = useIntl();
    return (<>
            {/* transition-opacity, not "all" — the default property would also animate the backdrop blur. */}
            <TransitionChild enter="transition-opacity ease-out-soft duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-out-soft duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
                <div className="fixed inset-0 bg-gray-900/35 backdrop-blur-[2px]"/>
            </TransitionChild>

            <div className="fixed inset-0">
                <div className="relative h-dvh w-screen">
                    <TransitionChild enter="transform transition-transform ease-out-soft duration-200" enterFrom="translate-x-full rtl:-translate-x-full" enterTo="translate-x-0" leave="transform transition-transform ease-out-soft duration-150" leaveFrom="translate-x-0" leaveTo="translate-x-full rtl:-translate-x-full">
                        <DialogPanel className={`
                                absolute end-0 top-0 flex h-dvh w-full ${maxWidth} transform flex-col
                                overflow-hidden rounded-s-2xl bg-white text-start shadow-overlay
                            `}>
                            {/* pt-safe, not pt-5 — full-height panel needs the safe-area inset in landscape, not a fixed value. */}
                            {/* DialogTitle holds only the text — including the close button made it announce "Title Close" on open. */}
                            <div className={"flex shrink-0 items-start gap-3 border-b border-line px-5 pb-3 pt-safe sm:px-6"}>
                                <DialogTitle className={"grow shrink truncate text-lg font-semibold tracking-title text-gray-900 sm:text-xl"}>
                                    {title}
                                </DialogTitle>
                                <IconButton label={formatMessage({ id: "close", defaultMessage: "Close" })} onClick={() => setOpen(false)} className={"shrink-0 text-gray-500 hover:bg-sunken hover:text-gray-900"}>
                                    <X className={"h-5 w-5"}/>
                                </IconButton>
                            </div>

                            <div className={"grow overflow-y-auto overscroll-contain px-5 pt-4 pb-safe sm:px-6"}>{children}</div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </>);
}
//# sourceMappingURL=modalRightCore.jsx.map